import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CloudPaymentsRegisterRequest as SchemaCloudPaymentsRegisterRequest } from '../schemas/CloudPaymentsRegisterRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Отправка заявки в CloudPayments
 */
export const CloudPaymentsRegisterContentType = 'application/json' as const;
export type CloudPaymentsRegisterRequest = SchemaCloudPaymentsRegisterRequest;
export type CloudPaymentsRegisterResponses = LinkCommonErrorResponses & {};
export type CloudPaymentsRegisterResponseSuccess = undefined;
export type CloudPaymentsRegisterSearchParams = undefined;
export type CloudPaymentsRegisterPathParameters = undefined;
export const CloudPaymentsRegisterUrl = '/cloudpayments/register' as const;
export const CloudPaymentsRegisterMethod = 'POST' as const;
export const getCloudPaymentsRegisterUrl = (_params?: CloudPaymentsRegisterPathParameters) => CloudPaymentsRegisterUrl;
